// ESM derivative of brand.json. The brand contract test enforces exact parity.
// Keeping this as plain JavaScript supports every Node 20 release and browser
// bundlers without version-sensitive JSON import attributes.
export const BRAND_IDENTITY = Object.freeze({
  id: 'streamlain',
  displayName: 'StreamLain',
  socialHandle: '@StreamLain',
  wordmarkAccentSuffix: 'Lain',
  wordmarkViewBoxWidth: 149,
  legacyDisplayNames: Object.freeze(['StreamLain']),
  aiDisplayName: 'Mate',
});

export const BRAND_DISPLAY_NAME = BRAND_IDENTITY.displayName;
export const BRAND_SOCIAL_HANDLE = BRAND_IDENTITY.socialHandle;
export const BRAND_WORDMARK_ACCENT_SUFFIX = BRAND_IDENTITY.wordmarkAccentSuffix;
export const BRAND_WORDMARK_VIEWBOX_WIDTH = BRAND_IDENTITY.wordmarkViewBoxWidth;
export const BRAND_LEGACY_DISPLAY_NAMES = BRAND_IDENTITY.legacyDisplayNames;
/** The AI's name in every product text and record. */
export const BRAND_AI_DISPLAY_NAME = BRAND_IDENTITY.aiDisplayName;
